import { handleRefHandlers, hasDefinedChildren } from "@utils/general";
import React from "react";

import { DASH_CHARACTER } from "../../constants";
import { TextAlign } from "../../enums";
import TestIds from "../../testIds";
import memoizeOneWithParamsCheck from "../../utils/memoizeOne";
import Tooltip from "../tooltip/Tooltip";
import { InnerTextWrapper, StyledText } from "./Text.styles";

interface IProps {
    isBig?: boolean;
    width?: string;
    maxRows?: number;
    isLight?: boolean;
    wrap?: boolean;
    /** Removes default padding and self align */
    isWithoutDefaultFormatting?: boolean;
    textAlign?: TextAlign;
    passRef?: React.Ref<HTMLDivElement>;
    className?: string;
    style?: React.CSSProperties;
    isDisabled?: boolean;
    isSynchronized?: boolean;
}

export default class Text extends React.PureComponent<IProps> {
    getHandleRef = memoizeOneWithParamsCheck((ref?: React.Ref<any>) => {
        return (element: HTMLDivElement) => {
            handleRefHandlers(element, ref, this.props.passRef);
        };
    });

    render() {
        return (
            <Tooltip content={this.props.children}
                     onlyShowWhenChildrenOverflowing>
                {(ref) =>
                    <StyledText ref={this.getHandleRef(ref)}
                                className={this.props.className}
                                isBig={this.props.isBig}
                                maxRows={this.props.maxRows}
                                wrap={this.props.wrap}
                                style={this.props.style}
                                _textAlign={this.props.textAlign}
                                isLight={this.props.isLight}
                                isDisabled={this.props.isDisabled}
                                isWithoutDefaultFormatting={this.props.isWithoutDefaultFormatting}
                                _width={this.props.width}
                                data-testid={TestIds.Text}>
                        <InnerTextWrapper>
                            {hasDefinedChildren(this.props.children) ? this.props.children : DASH_CHARACTER}
                        </InnerTextWrapper>
                    </StyledText>
                }
            </Tooltip>
        );
    }
}